import _defineProperty from "/home/runner/work/frontend-starter/frontend-starter/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/home/runner/work/frontend-starter/frontend-starter/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js";
import _slicedToArray from "/home/runner/work/frontend-starter/frontend-starter/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
var _excluded = ["__scopeMenu"],
    _excluded2 = ["forceMount"],
    _excluded3 = ["__scopeMenu", "loop", "trapFocus", "onOpenAutoFocus", "onCloseAutoFocus", "disableOutsidePointerEvents", "onEscapeKeyDown", "onPointerDownOutside", "onFocusOutside", "onInteractOutside", "onDismiss", "disableOutsideScroll", "allowPinchZoom", "portalled"],
    _excluded4 = ["__scopeMenu"],
    _excluded5 = ["__scopeMenu"],
    _excluded6 = ["disabled", "onSelect"],
    _excluded7 = ["__scopeMenu", "disabled", "textValue"],
    _excluded8 = ["checked", "onCheckedChange"],
    _excluded9 = ["value", "onValueChange"],
    _excluded10 = ["value"],
    _excluded11 = ["__scopeMenu", "forceMount"],
    _excluded12 = ["__scopeMenu"],
    _excluded13 = ["__scopeMenu"];

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e2) { throw _e2; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e3) { didErr = true; err = _e3; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { useId as e } from "@radix-ui/react-id";
import { useFocusGuards as n } from "@radix-ui/react-focus-guards";
import { useCallbackRef as t } from "@radix-ui/react-use-callback-ref";
import { useDirection as r } from "@radix-ui/react-use-direction";
import * as o from "@radix-ui/react-roving-focus";
import { createRovingFocusGroupScope as u } from "@radix-ui/react-roving-focus";
import { Portal as c } from "@radix-ui/react-portal";
import * as a from "@radix-ui/react-popper";
import { createPopperScope as i } from "@radix-ui/react-popper";
import { Primitive as s } from "@radix-ui/react-primitive";
import { Presence as l } from "@radix-ui/react-presence";
import { FocusScope as d } from "@radix-ui/react-focus-scope";
import { DismissableLayer as p } from "@radix-ui/react-dismissable-layer";
import { createContextScope as f } from "@radix-ui/react-context";
import { useComposedRefs as m, composeRefs as v } from "@radix-ui/react-compose-refs";
import { createCollection as g } from "@radix-ui/react-collection";
import { composeEventHandlers as M } from "@radix-ui/primitive";
import { hideOthers as h } from "aria-hidden";
import { RemoveScroll as C } from "react-remove-scroll";
import * as E from "react";
import w from "@babel/runtime/helpers/esm/extends";

var x = ["Enter", " "],
    b = ["ArrowUp", "PageDown", "End"],
    R = ["ArrowDown", "PageUp", "Home"].concat(b),
    _ = {
  ltr: [].concat(x, ["ArrowRight"]),
  rtl: [].concat(x, ["ArrowLeft"])
},
    y = {
  ltr: ["ArrowLeft"],
  rtl: ["ArrowRight"]
},
    _g = g("Menu"),
    _g2 = _slicedToArray(_g, 3),
    I = _g2[0],
    k = _g2[1],
    P = _g2[2],
    _f = f("Menu", [P, i, u]),
    _f2 = _slicedToArray(_f, 2),
    D = _f2[0],
    S = _f2[1];

export { S as createMenuScope };

var O = i(),
    T = u(),
    _D = D("Menu"),
    _D2 = _slicedToArray(_D, 2),
    L = _D2[0],
    A = _D2[1];

export var Menu = function Menu(e) {
  var n = e.__scopeMenu,
      _e$open = e.open,
      o = _e$open === void 0 ? !1 : _e$open,
      u = e.children,
      c = e.onOpenChange,
      _e$modal = e.modal,
      i = _e$modal === void 0 ? !0 : _e$modal,
      s = O(n),
      _E$useState = E.useState(null),
      _E$useState2 = _slicedToArray(_E$useState, 2),
      l = _E$useState2[0],
      d = _E$useState2[1],
      p = E.useRef(!1),
      f = t(c),
      m = r(l, e.dir);

  return E.useEffect(function () {
    var e = function e() {
      p.current = !0, document.addEventListener("pointerdown", n, {
        capture: !0,
        once: !0
      }), document.addEventListener("pointermove", n, {
        capture: !0,
        once: !0
      });
    },
        n = function n() {
      return p.current = !1;
    };

    return document.addEventListener("keydown", e, {
      capture: !0
    }), function () {
      document.removeEventListener("keydown", e, {
        capture: !0
      }), document.removeEventListener("pointerdown", n, {
        capture: !0
      }), document.removeEventListener("pointermove", n, {
        capture: !0
      });
    };
  }, []), /*#__PURE__*/E.createElement(a.Root, s, /*#__PURE__*/E.createElement(L, {
    scope: n,
    isSubmenu: !1,
    isUsingKeyboardRef: p,
    dir: m,
    open: o,
    onOpenChange: f,
    content: l,
    onContentChange: d,
    onRootClose: E.useCallback(function () {
      return f(!1);
    }, [f]),
    modal: i
  }, u));
};
/*#__PURE__*/

export var MenuSub = function MenuSub(n) {
  var r = n.__scopeMenu,
      o = n.children,
      _n$open = n.open,
      u = _n$open === void 0 ? !1 : _n$open,
      c = n.onOpenChange,
      i = A("MenuSub", r),
      s = O(r),
      _E$useState3 = E.useState(null),
      _E$useState4 = _slicedToArray(_E$useState3, 2),
      l = _E$useState4[0],
      d = _E$useState4[1],
      _E$useState5 = E.useState(null),
      _E$useState6 = _slicedToArray(_E$useState5, 2),
      p = _E$useState6[0],
      f = _E$useState6[1],
      m = t(c);

  return E.useEffect(function () {
    return !1 === i.open && m(!1), function () {
      return m(!1);
    };
  }, [i.open, m]), /*#__PURE__*/E.createElement(a.Root, s, /*#__PURE__*/E.createElement(L, {
    scope: r,
    isSubmenu: !0,
    isUsingKeyboardRef: i.isUsingKeyboardRef,
    dir: i.dir,
    open: u,
    onOpenChange: m,
    content: p,
    onContentChange: f,
    onRootClose: i.onRootClose,
    contentId: e(),
    trigger: l,
    onTriggerChange: d,
    triggerId: e(),
    modal: !1
  }, o));
};
/*#__PURE__*/

export var MenuAnchor = /*#__PURE__*/E.forwardRef(function (e, n) {
  var t = e.__scopeMenu,
      r = _objectWithoutProperties(e, _excluded),
      o = O(t);
  /*#__PURE__*/


  return E.createElement(a.Anchor, w({}, o, r, {
    ref: n
  }));
});
/*#__PURE__*/

var _D3 = D("MenuContent"),
    _D4 = _slicedToArray(_D3, 2),
    F = _D4[0],
    K = _D4[1];

export var MenuContent = /*#__PURE__*/E.forwardRef(function (e, n) {
  var t = e.forceMount,
      r = _objectWithoutProperties(e, _excluded2),
      o = A("MenuContent", e.__scopeMenu);
  /*#__PURE__*/


  return E.createElement(I.Provider, {
    scope: e.__scopeMenu
  }, /*#__PURE__*/E.createElement(l, {
    present: t || o.open
  }, /*#__PURE__*/E.createElement(I.Slot, {
    scope: e.__scopeMenu
  }, o.isSubmenu ? /*#__PURE__*/E.createElement(X, w({}, r, {
    ref: n
  })) : /*#__PURE__*/E.createElement(G, w({}, r, {
    ref: n
  })))));
});
var G = /*#__PURE__*/E.forwardRef(function (e, n) {
  return A("MenuContent", e.__scopeMenu).modal ? /*#__PURE__*/E.createElement(U, w({}, e, {
    ref: n
  })) : /*#__PURE__*/E.createElement(V, w({}, e, {
    ref: n
  }));
}),
    U = /*#__PURE__*/E.forwardRef(function (e, n) {
  var t = A("MenuContent", e.__scopeMenu),
      r = E.useRef(null),
      o = m(n, r);
  return E.useEffect(function () {
    var e = r.current;
    if (e) return h(e);
  }, []), /*#__PURE__*/E.createElement(B, w({}, e, {
    ref: o,
    trapFocus: t.open,
    disableOutsidePointerEvents: t.open,
    disableOutsideScroll: !0,
    onFocusOutside: M(e.onFocusOutside, function (e) {
      return e.preventDefault();
    }, {
      checkForDefaultPrevented: !1
    }),
    onDismiss: function onDismiss() {
      return t.onOpenChange(!1);
    }
  }));
}),
    V = /*#__PURE__*/E.forwardRef(function (e, n) {
  var t = A("MenuContent", e.__scopeMenu);
  /*#__PURE__*/

  return E.createElement(B, w({}, e, {
    ref: n,
    trapFocus: !1,
    disableOutsidePointerEvents: !1,
    disableOutsideScroll: !1,
    onDismiss: function onDismiss() {
      return t.onOpenChange(!1);
    }
  }));
}),
    X = /*#__PURE__*/E.forwardRef(function (e, n) {
  var t = A("MenuContent", e.__scopeMenu),
      r = E.useRef(null),
      o = m(n, r);
  return t.isSubmenu ? /*#__PURE__*/E.createElement(B, w({
    id: t.contentId,
    "aria-labelledby": t.triggerId
  }, e, {
    ref: o,
    align: "start",
    side: "rtl" === t.dir ? "left" : "right",
    portalled: !0,
    disableOutsidePointerEvents: !1,
    disableOutsideScroll: !1,
    trapFocus: !1,
    onOpenAutoFocus: function onOpenAutoFocus(e) {
      var n;
      t.isUsingKeyboardRef.current && (null === (n = r.current) || void 0 === n || n.focus()), e.preventDefault();
    },
    onCloseAutoFocus: function onCloseAutoFocus(e) {
      return e.preventDefault();
    },
    onFocusOutside: M(e.onFocusOutside, function (e) {
      e.target !== t.trigger && t.onOpenChange(!1);
    }),
    onEscapeKeyDown: M(e.onEscapeKeyDown, t.onRootClose),
    onKeyDown: M(e.onKeyDown, function (e) {
      var n = e.currentTarget.contains(e.target),
          r = y[t.dir].includes(e.key);
      var o;
      n && r && (t.onOpenChange(!1), null === (o = t.trigger) || void 0 === o || o.focus(), e.preventDefault());
    })
  })) : null;
}),
    B = /*#__PURE__*/E.forwardRef(function (e, t) {
  var r = e.__scopeMenu,
      _e$loop = e.loop,
      u = _e$loop === void 0 ? !1 : _e$loop,
      i = e.trapFocus,
      s = e.onOpenAutoFocus,
      l = e.onCloseAutoFocus,
      f = e.disableOutsidePointerEvents,
      v = e.onEscapeKeyDown,
      g = e.onPointerDownOutside,
      h = e.onFocusOutside,
      x = e.onInteractOutside,
      _ = e.onDismiss,
      y = e.disableOutsideScroll,
      I = e.allowPinchZoom,
      P = e.portalled,
      D = _objectWithoutProperties(e, _excluded3),
      S = A("MenuContent", r),
      L = O(r),
      K = T(r),
      G = k(r),
      _E$useState7 = E.useState(null),
      _E$useState8 = _slicedToArray(_E$useState7, 2),
      U = _E$useState8[0],
      V = _E$useState8[1],
      X = E.useRef(null),
      B = m(t, X, S.onContentChange),
      Y = E.useRef(0),
      Z = E.useRef(""),
      z = E.useRef(0),
      H = E.useRef(null),
      W = E.useRef("right"),
      q = E.useRef(0),
      N = P ? c : E.Fragment,
      Q = y ? C : E.Fragment,
      $ = y ? {
    allowPinchZoom: I
  } : void 0,
      ee = function ee(e) {
    var n, t;

    var r = Z.current + e,
        o = G().filter(function (e) {
      return !e.disabled;
    }),
        u = document.activeElement,
        c = null === (n = o.find(function (e) {
      return e.ref.current === u;
    })) || void 0 === n ? void 0 : n.textValue,
        a = function (e, n, t) {
      var r = n.length > 1 && Array.from(n).every(function (e) {
        return e === n[0];
      }) ? n[0] : n,
          o = t ? e.indexOf(t) : -1;
      var u = (c = e, a = Math.max(o, 0), c.map(function (e, n) {
        return c[(a + n) % c.length];
      }));
      var c, a;
      1 === r.length && (u = u.filter(function (e) {
        return e !== t;
      }));
      var i = u.find(function (e) {
        return e.toLowerCase().startsWith(r.toLowerCase());
      });
      return i !== t ? i : void 0;
    }(o.map(function (e) {
      return e.textValue;
    }), r, c),
        i = null === (t = o.find(function (e) {
      return e.textValue === a;
    })) || void 0 === t ? void 0 : t.ref.current;

    !function e(n) {
      Z.current = n, window.clearTimeout(Y.current), "" !== n && (Y.current = window.setTimeout(function () {
        return e("");
      }, 1e3));
    }(r), i && setTimeout(function () {
      return i.focus();
    });
  };

  E.useEffect(function () {
    return function () {
      return window.clearTimeout(Y.current);
    };
  }, []), n();
  var ne = E.useCallback(function (e) {
    var n, t;
    return W.current === (null === (n = H.current) || void 0 === n ? void 0 : n.side) && function (e, n) {
      if (!n) return !1;
      return function (e, n) {
        var t = e.x,
            r = e.y;
        var o = !1;

        for (var _e = 0, _u = n.length - 1; _e < n.length; _u = _e++) {
          var _c = n[_e].x,
              _a = n[_e].y,
              _i = n[_u].x,
              _s = n[_u].y;
          _a > r != _s > r && t < (_i - _c) * (r - _a) / (_s - _a) + _c && (o = !o);
        }

        return o;
      }({
        x: e.clientX,
        y: e.clientY
      }, n);
    }(e, null === (t = H.current) || void 0 === t ? void 0 : t.area);
  }, []);
  /*#__PURE__*/

  return E.createElement(N, null, /*#__PURE__*/E.createElement(Q, $, /*#__PURE__*/E.createElement(F, {
    scope: r,
    searchRef: Z,
    onItemEnter: E.useCallback(function (e) {
      ne(e) && e.preventDefault();
    }, [ne]),
    onItemLeave: E.useCallback(function (e) {
      var n;
      ne(e) || (null === (n = X.current) || void 0 === n || n.focus(), V(null));
    }, [ne]),
    onTriggerLeave: E.useCallback(function (e) {
      ne(e) && e.preventDefault();
    }, [ne]),
    pointerGraceTimerRef: z,
    onPointerGraceIntentChange: E.useCallback(function (e) {
      H.current = e;
    }, [])
  }, /*#__PURE__*/E.createElement(d, {
    asChild: !0,
    trapped: i,
    onMountAutoFocus: M(s, function (e) {
      var n;
      e.preventDefault(), null === (n = X.current) || void 0 === n || n.focus();
    }),
    onUnmountAutoFocus: l
  }, /*#__PURE__*/E.createElement(p, {
    asChild: !0,
    disableOutsidePointerEvents: f,
    onEscapeKeyDown: v,
    onPointerDownOutside: g,
    onFocusOutside: h,
    onInteractOutside: x,
    onDismiss: _
  }, /*#__PURE__*/E.createElement(o.Root, w({
    asChild: !0
  }, K, {
    dir: S.dir,
    orientation: "vertical",
    loop: u,
    currentTabStopId: U,
    onCurrentTabStopIdChange: V,
    onEntryFocus: function onEntryFocus(e) {
      S.isUsingKeyboardRef.current || e.preventDefault();
    }
  }), /*#__PURE__*/E.createElement(a.Content, w({
    role: "menu",
    "aria-orientation": "vertical",
    "data-state": j(S.open),
    dir: S.dir
  }, L, D, {
    ref: B,
    style: _objectSpread({
      outline: "none"
    }, D.style),
    onKeyDown: M(D.onKeyDown, function (e) {
      var n = e.target,
          t = e.currentTarget.contains(n),
          r = e.ctrlKey || e.altKey || e.metaKey,
          o = 1 === e.key.length;
      t && ("Tab" === e.key && e.preventDefault(), !r && o && ee(e.key));
      var u = X.current;
      if (e.target !== u) return;
      if (!R.includes(e.key)) return;
      e.preventDefault();
      var c = G().filter(function (e) {
        return !e.disabled;
      }).map(function (e) {
        return e.ref.current;
      });
      b.includes(e.key) && c.reverse(), function (e) {
        var n = document.activeElement;

        var _iterator = _createForOfIteratorHelper(e),
            _step;

        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var _t = _step.value;
            if (_t === n) return;
            if (_t.focus(), document.activeElement !== n) return;
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }
      }(c);
    }),
    onBlur: M(e.onBlur, function (e) {
      e.currentTarget.contains(e.target) || (window.clearTimeout(Y.current), Z.current = "");
    }),
    onPointerMove: M(e.onPointerMove, J(function (e) {
      var n = e.target,
          t = q.current !== e.clientX;

      if (e.currentTarget.contains(n) && t) {
        var _n = e.clientX > q.current ? "right" : "left";

        W.current = _n, q.current = e.clientX;
      }
    }))
  }))))))));
});
export var MenuGroup = /*#__PURE__*/E.forwardRef(function (e, n) {
  var t = e.__scopeMenu,
      r = _objectWithoutProperties(e, _excluded4);
  /*#__PURE__*/


  return E.createElement(s.div, w({
    role: "group"
  }, r, {
    ref: n
  }));
});
/*#__PURE__*/

export var MenuLabel = /*#__PURE__*/E.forwardRef(function (e, n) {
  var t = e.__scopeMenu,
      r = _objectWithoutProperties(e, _excluded5);
  /*#__PURE__*/


  return E.createElement(s.div, w({}, r, {
    ref: n
  }));
});
/*#__PURE__*/

export var MenuItem = /*#__PURE__*/E.forwardRef(function (e, n) {
  var _e$disabled = e.disabled,
      t = _e$disabled === void 0 ? !1 : _e$disabled,
      r = e.onSelect,
      o = _objectWithoutProperties(e, _excluded6),
      u = E.useRef(null),
      c = A("MenuItem", e.__scopeMenu),
      a = K("MenuItem", e.__scopeMenu),
      i = m(n, u),
      s = E.useRef(!1);
  /*#__PURE__*/


  return E.createElement(Y, w({}, o, {
    ref: i,
    disabled: t,
    onClick: M(e.onClick, function () {
      var e = u.current;

      if (!t && e) {
        var _n2 = new Event("menu.itemSelect", {
          bubbles: !0,
          cancelable: !0
        });

        e.addEventListener("menu.itemSelect", function (e) {
          return null == r ? void 0 : r(e);
        }, {
          once: !0
        }), e.dispatchEvent(_n2), _n2.defaultPrevented ? s.current = !1 : c.onRootClose();
      }
    }),
    onPointerDown: function onPointerDown(n) {
      var t;
      null === (t = e.onPointerDown) || void 0 === t || t.call(e, n), s.current = !0;
    },
    onPointerUp: M(e.onPointerUp, function (e) {
      var n;
      s.current || null === (n = e.currentTarget) || void 0 === n || n.click();
    }),
    onKeyDown: M(e.onKeyDown, function (e) {
      var n = "" !== a.searchRef.current;
      t || n && " " === e.key || x.includes(e.key) && (e.currentTarget.click(), e.preventDefault());
    })
  }));
});
/*#__PURE__*/

export var MenuSubTrigger = /*#__PURE__*/E.forwardRef(function (e, n) {
  var t = A("MenuSubTrigger", e.__scopeMenu),
      r = K("MenuSubTrigger", e.__scopeMenu),
      o = E.useRef(null),
      u = r.pointerGraceTimerRef,
      c = r.onPointerGraceIntentChange,
      a = {
    __scopeMenu: e.__scopeMenu
  },
      i = E.useCallback(function () {
    o.current && window.clearTimeout(o.current), o.current = null;
  }, []);
  return E.useEffect(function () {
    return i;
  }, [i]), E.useEffect(function () {
    var e = u.current;
    return function () {
      window.clearTimeout(e), c(null);
    };
  }, [u, c]), t.isSubmenu ? /*#__PURE__*/E.createElement(MenuAnchor, w({
    asChild: !0
  }, a), /*#__PURE__*/E.createElement(Y, w({
    id: t.triggerId,
    "aria-haspopup": "menu",
    "aria-expanded": t.open,
    "aria-controls": t.contentId,
    "data-state": j(t.open)
  }, e, {
    ref: v(n, t.onTriggerChange),
    onClick: function onClick(n) {
      var r;
      null === (r = e.onClick) || void 0 === r || r.call(e, n), e.disabled || n.defaultPrevented || (n.currentTarget.focus(), t.open || t.onOpenChange(!0));
    },
    onPointerMove: M(e.onPointerMove, J(function (n) {
      r.onItemEnter(n), n.defaultPrevented || e.disabled || t.open || o.current || (r.onPointerGraceIntentChange(null), o.current = window.setTimeout(function () {
        t.onOpenChange(!0), i();
      }, 100));
    })),
    onPointerLeave: M(e.onPointerLeave, J(function (e) {
      var n;
      i();
      var o = null === (n = t.content) || void 0 === n ? void 0 : n.getBoundingClientRect();

      if (o) {
        var c;

        var _n3 = null === (c = t.content) || void 0 === c ? void 0 : c.dataset.side,
            _a2 = "right" === _n3,
            _i2 = _a2 ? -5 : 5,
            _s2 = o[_a2 ? "left" : "right"],
            _l = o[_a2 ? "right" : "left"];

        r.onPointerGraceIntentChange({
          area: [{
            x: e.clientX + _i2,
            y: e.clientY
          }, {
            x: _s2,
            y: o.top
          }, {
            x: _l,
            y: o.top
          }, {
            x: _l,
            y: o.bottom
          }, {
            x: _s2,
            y: o.bottom
          }],
          side: _n3
        }), window.clearTimeout(u.current), u.current = window.setTimeout(function () {
          return r.onPointerGraceIntentChange(null);
        }, 300);
      } else {
        if (r.onTriggerLeave(e), e.defaultPrevented) return;
        r.onPointerGraceIntentChange(null);
      }
    })),
    onKeyDown: M(e.onKeyDown, function (n) {
      var o = "" !== r.searchRef.current;
      var u;
      e.disabled || o && " " === n.key || _[t.dir].includes(n.key) && (t.onOpenChange(!0), null === (u = t.content) || void 0 === u || u.focus(), n.preventDefault());
    })
  }))) : null;
});
/*#__PURE__*/

var Y = /*#__PURE__*/E.forwardRef(function (e, n) {
  var t = e.__scopeMenu,
      _e$disabled2 = e.disabled,
      r = _e$disabled2 === void 0 ? !1 : _e$disabled2,
      u = e.textValue,
      c = _objectWithoutProperties(e, _excluded7),
      a = K("MenuItem", t),
      i = T(t),
      l = E.useRef(null),
      d = m(n, l),
      _E$useState9 = E.useState(""),
      _E$useState10 = _slicedToArray(_E$useState9, 2),
      p = _E$useState10[0],
      f = _E$useState10[1];

  return E.useEffect(function () {
    var e = l.current;
    var n;
    e && f((null !== (n = e.textContent) && void 0 !== n ? n : "").trim());
  }, [c.children]), /*#__PURE__*/E.createElement(I.ItemSlot, {
    scope: t,
    disabled: r,
    textValue: null != u ? u : p
  }, /*#__PURE__*/E.createElement(o.Item, w({
    asChild: !0
  }, i, {
    focusable: !r
  }), /*#__PURE__*/E.createElement(s.div, w({
    role: "menuitem",
    "aria-disabled": r || void 0,
    "data-disabled": r ? "" : void 0
  }, c, {
    ref: d,
    onPointerMove: M(e.onPointerMove, J(function (e) {
      if (r) a.onItemLeave(e);else if (a.onItemEnter(e), !e.defaultPrevented) {
        e.currentTarget.focus();
      }
    })),
    onPointerLeave: M(e.onPointerLeave, J(function (e) {
      return a.onItemLeave(e);
    }))
  }))));
});
export var MenuCheckboxItem = /*#__PURE__*/E.forwardRef(function (e, n) {
  var _e$checked = e.checked,
      t = _e$checked === void 0 ? !1 : _e$checked,
      r = e.onCheckedChange,
      o = _objectWithoutProperties(e, _excluded8);
  /*#__PURE__*/


  return E.createElement(H, {
    scope: e.__scopeMenu,
    checked: t
  }, /*#__PURE__*/E.createElement(MenuItem, w({
    role: "menuitemcheckbox",
    "aria-checked": t
  }, o, {
    ref: n,
    "data-state": q(t),
    onSelect: M(o.onSelect, function () {
      return null == r ? void 0 : r(!t);
    }, {
      checkForDefaultPrevented: !1
    })
  })));
});
/*#__PURE__*/

var _D5 = D("MenuRadioGroup", {
  value: void 0,
  onValueChange: function onValueChange() {}
}),
    _D6 = _slicedToArray(_D5, 2),
    Z = _D6[0],
    z = _D6[1];

export var MenuRadioGroup = /*#__PURE__*/E.forwardRef(function (e, n) {
  var r = e.value,
      o = e.onValueChange,
      u = _objectWithoutProperties(e, _excluded9),
      c = t(o);
  /*#__PURE__*/


  return E.createElement(Z, {
    scope: e.__scopeMenu,
    value: r,
    onValueChange: c
  }, /*#__PURE__*/E.createElement(MenuGroup, w({}, u, {
    ref: n
  })));
});
/*#__PURE__*/

export var MenuRadioItem = /*#__PURE__*/E.forwardRef(function (e, n) {
  var t = e.value,
      r = _objectWithoutProperties(e, _excluded10),
      o = z("MenuRadioItem", e.__scopeMenu),
      u = t === o.value;
  /*#__PURE__*/


  return E.createElement(H, {
    scope: e.__scopeMenu,
    checked: u
  }, /*#__PURE__*/E.createElement(MenuItem, w({
    role: "menuitemradio",
    "aria-checked": u
  }, r, {
    ref: n,
    "data-state": q(u),
    onSelect: M(r.onSelect, function () {
      var e;
      return null === (e = o.onValueChange) || void 0 === e ? void 0 : e.call(o, t);
    }, {
      checkForDefaultPrevented: !1
    })
  })));
});
/*#__PURE__*/

var _D7 = D("MenuItemIndicator", {
  checked: !1
}),
    _D8 = _slicedToArray(_D7, 2),
    H = _D8[0],
    W = _D8[1];

export var MenuItemIndicator = /*#__PURE__*/E.forwardRef(function (e, n) {
  var t = e.__scopeMenu,
      r = e.forceMount,
      o = _objectWithoutProperties(e, _excluded11),
      u = W("MenuItemIndicator", t);
  /*#__PURE__*/


  return E.createElement(l, {
    present: r || u.checked
  }, /*#__PURE__*/E.createElement(s.span, w({}, o, {
    ref: n,
    "data-state": q(u.checked)
  })));
});
/*#__PURE__*/

export var MenuSeparator = /*#__PURE__*/E.forwardRef(function (e, n) {
  var t = e.__scopeMenu,
      r = _objectWithoutProperties(e, _excluded12);
  /*#__PURE__*/


  return E.createElement(s.div, w({
    role: "separator",
    "aria-orientation": "horizontal"
  }, r, {
    ref: n
  }));
});
/*#__PURE__*/

export var MenuArrow = /*#__PURE__*/E.forwardRef(function (e, n) {
  var t = e.__scopeMenu,
      r = _objectWithoutProperties(e, _excluded13),
      o = O(t);
  /*#__PURE__*/


  return E.createElement(a.Arrow, w({}, o, r, {
    ref: n
  }));
});
/*#__PURE__*/

function j(e) {
  return e ? "open" : "closed";
}

function q(e) {
  return e ? "checked" : "unchecked";
}

function J(e) {
  return function (n) {
    return "mouse" === n.pointerType ? e(n) : void 0;
  };
}

export var Root = Menu;
export var Sub = MenuSub;
export var Anchor = MenuAnchor;
export var SubTrigger = MenuSubTrigger;
export var Content = MenuContent;
export var Group = MenuGroup;
export var Label = MenuLabel;
export var Item = MenuItem;
export var CheckboxItem = MenuCheckboxItem;
export var RadioGroup = MenuRadioGroup;
export var RadioItem = MenuRadioItem;
export var ItemIndicator = MenuItemIndicator;
export var Separator = MenuSeparator;
export var Arrow = MenuArrow;